window.LN = window.LN || {};
LN.App = {};
LN.Core = {};
LN.Config = {};
LN.Model = {};
LN.Service = {};
LN.Helper = {};
LN.Controller = {};
LN.Handler = {};
LN.Router = {};
LN.View = {};
LN.Message = {};
LN.Message.Analytics = {};
LN.Analytics = {};
LN.Hotjar = {};
LN.Validation = {};
LN.IFrames = {};
LN.AppEvent = {};
LN.SWG = {};
LN.FacebookInstantArticles = {};
LN.ViewPartial = {};


if (!Object.values) {
    Object.values = function (object) {
        return Object.keys(object).map(key => object[key]);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/core.js